// App
import { useAuth } from "../contexts/authContext";

// UI
import { Col, Row } from "react-bootstrap";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

export default function LoggedOutBanner() {
  const { loggedOut } = useAuth();

  if (!loggedOut) return null;

  return (
    <Dialog open={loggedOut}>
      <DialogContent>
        <Row>
          <Col className="text-center">
            <DialogTitle>You've been logged out</DialogTitle>
            <hr />
            <Button
              sx={{
                minWidth: "250px",
              }}
              variant="contained"
              type="submit"
              onClick={() => {
                window.location = "/login";
              }}
            >
              Login
            </Button>
          </Col>
        </Row>
      </DialogContent>
    </Dialog>
  );
}
